import type { Assessment } from "@/core/types";
import { assessmentRequestsTyped } from "@/api/(requests)/assessmentTyped";

type GetAssessmentDefinitionprops = {
  id: string;
};

export async function getDefinition({ id }: GetAssessmentDefinitionprops): Promise<Assessment> {
  return assessmentRequestsTyped.get_definition({
    context: { showLoader: false },
    urlParams: { assessmentId: id },
  });
}
